import { MuiAlert, strIsNullOrEmpty } from '@fox/atoms';
import { PaymentMethod } from '@fox/finance';
import { FlexColumnSmallSpaced, Padded } from '@fox/layout';
import React from 'react';
import styled from 'styled-components';
import { useFinancialContext } from '../../../financial-config-context';
import { convertMemberPortalToSfMethodEnumValue } from '../shared';
import { CreditCardList } from './credit-card-display';
import { DirectDebitList } from './direct-debit-display';

const ResponsiveWrapper = styled.div`
	@media (max-width: 800px) {
		.padding {
			padding: 0px;
		}
	}
`;

export const PaymentDetails: React.FC = ({
	useLinkedOrganisationData,
	allowedProviders,
	allowedPlanCategories
}: {
	useLinkedOrganisationData: boolean;
	allowedProviders?: string[];
	allowedPlanCategories?: string[];
}) => {
	const { providers, customerError, subscriptionsError, getCustomers, getSubscriptions, orgSubscriptionsError, orgCustomerError } =
		useFinancialContext();
	const customerData = getCustomers(useLinkedOrganisationData);
	const subscriptionData = getSubscriptions(useLinkedOrganisationData, allowedPlanCategories);

	if (!strIsNullOrEmpty(customerError) && !useLinkedOrganisationData) return <MuiAlert severity="error">{customerError}</MuiAlert>;
	if (!strIsNullOrEmpty(orgCustomerError) && useLinkedOrganisationData) return <MuiAlert severity="error">{orgCustomerError}</MuiAlert>;
	if (!strIsNullOrEmpty(subscriptionsError) && !useLinkedOrganisationData)
		return <MuiAlert severity="error">{subscriptionsError}</MuiAlert>;
	if (!strIsNullOrEmpty(orgSubscriptionsError) && useLinkedOrganisationData)
		return <MuiAlert severity="error">{orgSubscriptionsError}</MuiAlert>;
	if (!customerData || !subscriptionData) return null;

	const providersToUse = allowedProviders?.length
		? providers.filter(p => allowedProviders.includes(p.provider.toLowerCase()))
		: providers;

	// here we will just list a bunch of credit CreditCardDisplay components, we will add the payment add components here as well
	// we should just create a credit card display with menu or something
	return (
		<ResponsiveWrapper>
			<Padded className="padding">
				<FlexColumnSmallSpaced>
					<>
						{providersToUse?.length ? (
							providersToUse.map(prov => {
								const method = convertMemberPortalToSfMethodEnumValue(prov.method);
								return (
									<div key={`${prov.provider}-${prov.method}`}>
										{method == PaymentMethod.CreditCard ? (
											<CreditCardList
												showProviderName={providersToUse.length > 1}
												provider={prov}
												useLinkedOrganisationData={useLinkedOrganisationData}
												allowedPlanCategories={allowedPlanCategories}
											/>
										) : method === PaymentMethod.DirectDebit ? (
											<DirectDebitList
												showProviderName={providersToUse.length > 1}
												provider={prov}
												useLinkedOrganisationData={useLinkedOrganisationData}
												allowedPlanCategories={allowedPlanCategories}
											/>
										) : null}
									</div>
								);
							})
						) : (
							<MuiAlert severity="info">No payment providers available</MuiAlert>
						)}
					</>
				</FlexColumnSmallSpaced>
			</Padded>
		</ResponsiveWrapper>
	);
};
